import { Component, inject, OnInit, signal } from '@angular/core';
import { ApplicationDataService } from '@app/services/application-data.service';
import { CommonUtilityService } from '@app/services/common-utility.service';
import { SessionStorageService } from '@upr-web-primer/storage';
import {
  IdentityVerificationComponent,
  IdentityVerificationStep,
} from '../identity-verification.component';

@Component({
  selector: 'app-signup-identity-verification',
  templateUrl: './signup-identity-verification.component.html',
  styleUrl: './signup-identity-verification.component.scss',
  imports: [IdentityVerificationComponent],
})
export class SignupIdentityVerificationComponent implements OnInit {
  readonly email = signal('');
  readonly guestId = signal('');
  readonly initialStep = signal<IdentityVerificationStep>('step-1');

  private readonly common = inject(CommonUtilityService);
  private readonly applicationDataService = inject(ApplicationDataService);
  private readonly sessionStorage = inject(SessionStorageService);
  private readonly appRoutes = inject<any>('AppRoutes' as any);

  ngOnInit(): void {
    this.email.set(this.getCreateAccountEmail());
    this.guestId.set(this.getCreateAccountGuestId());
  }

  onCompleted(): void {
    if (this.sessionStorage.getItem('dtfReturnUrl')) {
      return;
    }
    const redirectUri = this.getCreateAccountRedirectUri();

    if (redirectUri) {
      this.common.changeUrl(redirectUri);
      return;
    }

    this.common.changeRoute(this.appRoutes.SIGNUP_COMPLETE);
  }

  onCanceled(): void {
    const isWtsCartCreateAccount = this.isWtsCartCreateAccount();
    const redirectUri = this.getCreateAccountRedirectUri();

    this.clearSignupIdentityVerificationSession();

    if (isWtsCartCreateAccount) {
      this.common.onClickRedirectWTS('', '', true, false);
      return;
    }

    if (redirectUri) {
      this.common.changeUrl(redirectUri);
      return;
    }

    this.common.changeRoute(this.appRoutes.CREATE_ACCOUNT);
  }

  onLimitReached(): void {
    this.initialStep.set('limit-reached');
  }

  private getCreateAccountEmail(): string {
    const email = this.sessionStorage.getItem('EMAIL_USER_ID');

    return email?.trim() || '';
  }

  private getCreateAccountGuestId(): string {
    const guestId = this.sessionStorage.getItem('LOGGEDIN_GUEST_ID');

    return guestId?.trim() || '';
  }

  private getCreateAccountRedirectUri(): string {
    const redirectUri = this.sessionStorage.getItem(
      'CREATE_ACCOUNT_REDIRECT_URI',
    );

    return redirectUri?.trim() || '';
  }

  private isWtsCartCreateAccount(): boolean {
    return !!this.applicationDataService.getCookieInfo('cartCreateAccount');
  }

  private clearSignupIdentityVerificationSession(): void {
    this.sessionStorage.removeItem('EMAIL_USER_ID');
    this.sessionStorage.removeItem('LOGGEDIN_GUEST_ID');
    this.sessionStorage.removeItem('CREATE_ACCOUNT_REDIRECT_URI');
    this.sessionStorage.removeItem('dtfReturnUrl');
  }
}
